<template>
    <section class="p-2 widget my-2">
        <a
            class="font-weight-bold float-right "
            :class="
                canEditClientEmr ? 'text-primary cursor-pointer' : 'text-muted cursor-not-allowed'
            "
            @click="canEditClientEmr ? editProfile() : null"
            >Edit</a
        >
        <div class="row">
            <div class="col-3">
                <div class="bg-white position-relative">
                    <span
                        class="position-absolute h-100 w-100 d-flex justify-content-center align-items-center hover-reveal cursor-pointer"
                        @click="() => (cropperIsActive = !cropperIsActive)"
                        >Change</span
                    >
                    <img
                        class="position-relative img-fluid profile-image hover-50"
                        :src="
                            patient.profile_photo_url
                                ? patient.profile_photo_url
                                : '../../../images/default_patient.jpeg'
                        "
                    />
                </div>
                <image-cropper
                    v-model="cropperIsActive"
                    :url="`/api/patients/${patient.id}/profile_photo`"
                    field="file"
                    langType="en"
                    :width="300"
                    :height="300"
                    @crop-upload-success="handlePhotoUploadSuccess"
                    @crop-upload-fail="handlePhotoUploadFailure"
                    noCircle
                />
            </div>
            <div class="col-9 d-flex flex-column justify-content-center">
                <p class="mb-0 text-uppercase font-weight-bold" data-private="lipsum">
                    {{ patient.name }}
                </p>
                <p class="mb-0 font-weight-bold">goLOTUS ID: {{ patient.id }}</p>
                <p class="mb-0">
                    Date of birth:
                    {{ patient.dob ? moment(patient.dob).format("MM/DD/YYYY") : null }}
                </p>
                <p class="mb-0">Gender: {{ patient.gender }}</p>
            </div>
        </div>
        <p class="my-2">
            <span class="font-weight-bold">Parent email: </span> {{ patient.parent_email }}
        </p>
        <template v-for="(a, i) in patient.addresses">
            <p class="mb-1 font-weight-bold">{{ i ? `Address #${i + 1}` : `Home Address` }}:</p>
            <p class="mb-0">{{ a.address1 }}</p>
            <p class="mb-0">{{ a.address2 }}</p>
            <p class="mb-0">{{ a.city }} {{ a.state }} {{ a.zip }}</p>
        </template>
        <modal-component
            :id="'patient-profile'"
            :title="modal.title"
            :visible="modal.visible"
            @close="resetModal()"
        >
            <form class="p-3">
                <div class="form-group row">
                    <label for="first_name" class="col-6 mb-1">First name:</label>
                    <input
                        id="first_name"
                        type="text"
                        class="form-control form-control-sm col-6 mb-1"
                        v-model="payload.first_name"
                    />
                </div>
                <div class="form-group row">
                    <label for="last_name" class="col-6 mb-1">Last name:</label>
                    <input
                        id="last_name"
                        type="text"
                        class="form-control form-control-sm col-6 mb-1"
                        v-model="payload.last_name"
                    />
                </div>
                <div class="form-group row">
                    <label class="col-6">Date of Birth:</label>
                    <div class="col-6 px-0">
                        <v-date-picker
                            class="picker-container"
                            popover-align="left"
                            v-model="payload.dob"
                        ></v-date-picker>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="gender" class="col-6">Gender:</label>
                    <div class="col-6 px-0">
                        <select
                            v-model="payload.gender"
                            id="gender"
                            class="form-control form-control-sm"
                            required
                        >
                            <option selected disabled :value="null">Please choose one</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="parent_email" class="col-6 mb-1">Parent email:</label>
                    <input
                        id="parent_email"
                        type="email"
                        class="form-control form-control-sm col-6 mb-1"
                        v-model="payload.parent_email"
                    />
                </div>
                <template v-for="(a, i) in payload.addresses">
                    <p class="mb-1 font-weight-bold">
                        {{ i ? `Address #${i + 1}` : `Home Address` }}:
                    </p>
                    <div class="form-group row mb-0">
                        <label for="address1" class="col-6 mb-1">Address 1:</label>
                        <input
                            id="address1"
                            type="text"
                            class="form-control form-control-sm col-6 mb-1"
                            v-model="a.address1"
                        />
                    </div>
                    <div class="form-group row mb-0">
                        <label for="address2" class="col-6 mb-1">Address 2:</label>
                        <input
                            id="address2"
                            type="text"
                            class="form-control form-control-sm col-6 mb-1"
                            v-model="a.address2"
                        />
                    </div>
                    <div class="form-group row mb-0">
                        <label for="city" class="col-6 mb-1">City:</label>
                        <input
                            id="city"
                            type="text"
                            class="form-control form-control-sm col-6 mb-1"
                            v-model="a.city"
                        />
                    </div>
                    <div class="form-group row mb-0">
                        <label for="state" class="col-6 mb-1">State/Zip:</label>
                        <input
                            id="state"
                            v-mask="'AA'"
                            type="text"
                            class="form-control form-control-sm col-2 mb-1"
                            v-model="a.state"
                        />
                        <input
                            id="zip"
                            v-mask="'#####'"
                            type="text"
                            class="form-control form-control-sm col-2 mb-1"
                            v-model="a.zip"
                        />
                    </div>
                </template>

                <div v-show="validationMessage" class="alert alert-danger">
                    <a href="#" class="close" data-dismiss="alert">&times;</a>
                    {{ validationMessage }}
                </div>

                <div class="d-flex justify-content-end">
                    <button
                        class="btn btn-sm btn-primary text-white"
                        @click.prevent="saveProfile()"
                    >
                        Save
                    </button>
                </div>
            </form>
        </modal-component>
    </section>
</template>

<script>
import ImageCropper from "../widgets/ImageCropper";
import ModalComponent from "../ui/ModalComponent";
import { permissions } from "../../plugins/permissions";
import { helpers } from "../../plugins/helpers";

export default {
    name: "PatientProfile",
    props: ["patient"],
    mixins: [permissions],
    components: {
        ModalComponent,
        ImageCropper,
    },
    data() {
        return {
            modal: {
                visible: false,
                title: "Edit Patient Profile",
            },
            payload: this.generatePayload(),
            validationMessage: "",
            cropperIsActive: false,
        };
    },
    methods: {
        getCopy(obj) {
            return JSON.parse(JSON.stringify(obj));
        },

        editProfile() {
            if (!this.canEditClientEmr) return;
            const patient = { ...this.patient };
            if (typeof this.payload === "object") {
                Object.keys(this.payload).forEach(k => {
                    this.payload[k] = this.getCopy(patient[k]); //We don't want to update the view before save
                });
            }
            if (!this.payload.addresses.length) {
                this.payload.addresses.push({
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zip: null,
                });
            }
            this.payload.dob = this.patient.dob ? this.moment(this.patient.dob).toDate() : null;
            this.modal.visible = true;
        },

        generatePayload() {
            return {
                first_name: null,
                last_name: null,
                parent_email: null,
                dob: null,
                gender: null,
                addresses: [
                    {
                        address1: null,
                        address2: null,
                        city: null,
                        state: null,
                        zip: null,
                    },
                ],
            };
        },

        resetModal() {
            this.modal.visible = false;
            this.payload = this.generatePayload();
        },

        validatePayload(payload) {
            if (!payload.first_name) {
                this.validationMessage = `First name needs to be filled.`;
                return null;
            }
            if (!payload.last_name) {
                this.validationMessage = `Last name needs to be filled.`;
                return null;
            }
            if (!payload.dob) {
                this.validationMessage = `Date of birth needs to be filled.`;
                return null;
            }
            if (!payload.addresses[0].address1) {
                this.validationMessage = `Address needs to be filled.`;
                return null;
            }
            if (!payload.addresses[0].city) {
                this.validationMessage = `City needs to be filled.`;
                return null;
            }
            if (!payload.addresses[0].state) {
                this.validationMessage = `State needs to be filled.`;
                return null;
            }
            if (!payload.addresses[0].zip) {
                this.validationMessage = `Zip needs to be filled.`;
                return null;
            }
            return payload;
        },

        saveProfile() {
            this.validationMessage = null;
            let payload = { ...this.payload };
            payload.dob = payload.dob ? this.moment(payload.dob).format("YYYY-MM-DD") : null;
            //payload = this.validatePayload(payload);
            payload = helpers.cleanEmptyProperties(payload);
            if (!payload) return;
            axios
                .patch(`/api/patients/${this.patient.id}`, payload)
                .then(response => {
                    this.updatePatientInHeader(_.get(response, "data.data", null));
                    this.resetModal();
                    this.$emit("patient-saved");
                })
                .catch(e => {
                    console.error(e);
                });
        },

        updatePatientInHeader(payload) {
            if (payload) {
                let headerPatient = this.$root.userOrgClients.find(
                    patient => patient.id === this.patient.id
                );
                headerPatient.name = `${payload.first_name} ${payload.last_name}`;
            }
        },

        handlePhotoUploadSuccess({ status, image }) {
            this.patient.profile_photo_url = image;
        },

        handlePhotoUploadFailure(err) {
            console.error(err);
        },
    },
};
</script>

<style scoped lang="scss">
.hover-reveal {
    transition: all 0.3s;
    z-index: 2;
    opacity: 0;
}
.hover-reveal:hover {
    opacity: 1;
}

.hover-reveal:hover + .hover-50 {
    transition: all 0.3s;
    opacity: 0.5;
}
</style>
